import React from "react";
import Form from "react-bootstrap/Form";

import NavBar from "../NavBar/NavBar";
import { FaAngleLeft } from "react-icons/fa";
import addRole from "../../images/icons/addRole.png";
import billing from "../../images/icons/billing.png";
import Delete from "../../images/icons/delete.png";
import Rectangle from "../../images/Rectangle.png";
import vpn_key from "../../images/icons/vpn_key.png";
import pp1 from "../../images//pp2.png";


import UserWallbox from "./UserSingle/UserWallbox";
import AllActivities from "./UserSingle/AllActivities";

import { Link } from "react-router-dom";
import { AiOutlineSearch } from "react-icons/ai";
import { IoMdKey } from "react-icons/io";


const UserSingle = () => {
  return (
    <>
      <NavBar />
      <main className="wrapper">
        <div className="page-content">
          <div className="wallbox-area">
            <div className="pages-title-list">
              <ul>
                <li>
                  <Link to="/user">All Users</Link>
                </li>
                <li>
                  <span>Julian Leudesdorff </span>
                </li>
              </ul>
            </div>

            <div className="wallbox_single_content">
              <div className="single_all_list">
                <ul className="box_progress">
                  <li>
                    <Link to="/user">
                      <FaAngleLeft /> Back to all users
                    </Link>
                  </li>
                  <li>
                    <span>Users Functions</span>
                  </li>
                  <li>
                    <Link to="">
                      <img src={addRole} /> Reset Password
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <img src={addRole} /> Add Role to User
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <img src={billing} /> Billing Details
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <img src={Delete} /> Delete Wallbox
                    </Link>
                  </li>
                </ul>
                <ul className="box_progress">
                  {/* <li>Wallbox Progress</li> */}
                </ul>
              </div>
              <div className="details_cont">
                <div className="wallbox_details">
                  <div className="h5">User Details</div>
                  <div className="wallbox_details_content">
                    <form action="">
                      <div className="box_group">
                        <label>Product Type</label>
                        <input type="text" value="Charge S" />
                      </div>
                      <div className="box_group">
                        <label><IoMdKey/> Environment Key (Wallbox Serial) </label>
                        <input type="text" value="POJ-103949543129" />
                      </div>
                      <div className="box_group">
                        <label>Firmware Version</label>
                        <input type="text" value="0.73a" />
                      </div>
                      <div className="box_group">
                        <label>Date installed</label>
                        <input type="text" value="2021-10-26" />
                      </div>
                      <div className="box_group">
                        <label>Owner</label>
                        <input type="text" value="Jonas Moßler" />
                      </div>
                      <div className="box_group">
                        <label>Installed Adresse</label>
                        <input
                          type="text"
                          value="Turley-Straße 8, 68167 Mannheim"
                        />
                      </div>
                      <div className="box_group">
                        <label>Company Name</label>
                        <input type="text" value="POWERJames GmbH" />
                      </div>
                    </form>
                    <div className="box_right_img">
                      <img src={pp1} />
                      <span>Status</span>
                      <span className="Running">Active</span>
                    </div>
                  </div>
                </div>
                <div className="user_wallbox">
                  <div className="h5">Roles in Environments</div>
                  <form action="">
                    <input type="search" placeholder="Search Product..." />
                    <button type="submit">
                      <AiOutlineSearch />
                    </button>
                  </form>
                  <UserWallbox />
                </div>
              </div>
              <div className="allActivities">
                <AllActivities />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default UserSingle;
